// Örnek servis codiagno login
import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "/foodmenu";

export default {
  getMenus(
    startDate = "",
    endDate = "",
    pageSize = 15,
    page = 1
  ) {
     if(pageSize=="Tümü"){
       pageSize=" ";
     }
      return axios.get(
        `/admin/foodmenu?StartDate=${startDate}&EndDate=${endDate}&PageSize=${pageSize}&Page=${page}`
      );
  },
  //Axios specifically looks for word > "data"
  deleteMenus(data) {
    return axios.put(`${RESOURCE_NAME}/delete/menus`, data);
  },
  createNewFoodMenuExcel(formData) {
    return axios.post(`${RESOURCE_NAME}/excel`, formData, {
      contentType: "multipart/form-data",
    });
  },
};
